// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from 'app/common/lib/i18n';
import ResourceFactory from 'app/common/lib/ResourceFactory';
import type { Dispatch } from 'redux';
import {
  conversationCreate,
  conversationOpen,
  conversationShow,
} from 'app/common/redux/actions/conversations';
import { Box, Button, Flyout, TextArea } from 'gestalt';

type Props = {
  dispatch: Dispatch<any>,
  userId: string,
};
type State = {
  draftMessage: string,
  isDraftFlyoutOpen: boolean,
};
class MessageButton extends Component<Props, State> {
  state = {
    isDraftFlyoutOpen: false,
    draftMessage: '',
  };
  handleToggleFlyout = () => {
    this.setState({
      isDraftFlyoutOpen: !this.state.isDraftFlyoutOpen,
    });
  };
  handleDismissFlyout = () => {
    this.setState({
      isDraftFlyoutOpen: false,
    });
  };
  handleDraftMessageChange = ({ value }: { value: string }) => {
    this.setState({
      draftMessage: value,
    });
  };
  handleSubmit = () => {
    const message = this.state.draftMessage;
    this.setState({
      isDraftFlyoutOpen: false,
      draftMessage: '',
    });

    const sendMessageResource = ResourceFactory.create('ConversationsResource', {
      user_ids: [this.props.userId],
      text: message,
    });
    sendMessageResource.callCreate().then((response) => {
      const { dispatch } = this.props;
      const conversation = response && response.resource_response.data;
      dispatch(conversationCreate(conversation));
      dispatch(conversationShow(conversation.id));
      dispatch(conversationOpen(conversation.id));
    });
  };
  anchor: HTMLElement;
  render() {
    const { isDraftFlyoutOpen, draftMessage } = this.state;
    return (
      <Box>
        <div
          ref={(c) => {
            if (c) {
              this.anchor = c;
            }
          }}
        >
          <Button
            inline
            text={i18n._('Message', 'button text label to send a message to this user')}
            onClick={this.handleToggleFlyout}
          />
        </div>
        {isDraftFlyoutOpen ? (
          <Flyout
            anchor={this.anchor}
            idealDirection="down"
            onDismiss={this.handleDismissFlyout}
            size="md"
          >
            <Box padding={3} width="100%">
              <TextArea
                id="message"
                value={draftMessage}
                onChange={this.handleDraftMessageChange}
                placeholder={i18n._(
                  'Add a message',
                  'text placeholder when sending a message to another user',
                )}
              />
              <Box marginTop={3}>
                <Button
                  color="red"
                  text={i18n._('Send', 'Button text label to send this message to this user')}
                  disabled={!draftMessage.trim()}
                  onClick={this.handleSubmit}
                />
              </Box>
            </Box>
          </Flyout>
        ) : null}
      </Box>
    );
  }
}

export default connect<*, *, _, _, _, _>()(MessageButton);
